import { ToastContainer } from "react-toastify";
import "./assets/scss/App.scss";
import Routers from "./router/router";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import MixpanelService from "utils/mixpanel";

const App = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize Google Analytics
    if (process.env.REACT_APP_CLIENT_MEASUREMENT_ID) {
      ReactGA.initialize([
        {
          trackingId: process.env.REACT_APP_CLIENT_MEASUREMENT_ID,
        },
      ]);
    }

    // Initialize Mixpanel
    MixpanelService.initialize();

    // Listen for messages from service worker (e.g. notification clicks)
    if ("serviceWorker" in navigator) {
      const handleSwMessage = (event) => {
        if (event.data?.type === "NOTIFICATION_OPENED") {
          MixpanelService.track("Notification_Opened", event.data.payload || {});
        }
        // Push click: the service worker can't navigate this tab itself
        if (event.data?.type === "NOTIFICATION_NAVIGATE" && event.data.url) {
          window.location.assign(event.data.url);
        }
      };

      navigator.serviceWorker.addEventListener("message", handleSwMessage);

      return () => {
        navigator.serviceWorker.removeEventListener("message", handleSwMessage);
      };
    }
  }, []);

  useEffect(() => {
    let timerId;
    let attempts = 0;

    const checkAndTrack = () => {
      const PageTitle = document?.title;
      
      // Default index.html title is "Purple PRN". If it's still just "Purple PRN",
      // we wait for React.lazy/Suspense chunks to load and react-helmet to apply the true title.
      if (PageTitle === "Purple PRN" && attempts < 20) {
        attempts++;
        timerId = setTimeout(checkAndTrack, 250); // wait up to 5 seconds
        return;
      }

      // Strip "Purple PRN - " prefix for tracking
      const cleanTitle = PageTitle ? PageTitle.replace(/^Purple\s*PRN\s*-\s*/i, '').trim() : PageTitle;
      
      ReactGA.send({
        hitType: "pageview",
        page: location?.pathname,
        title: cleanTitle,
      });

      MixpanelService.trackPageViewed({
        Page_name: cleanTitle || location?.pathname,
      });
    };

    // Start polling to track the page view
    timerId = setTimeout(checkAndTrack, 100);

    return () => clearTimeout(timerId);
  }, [location?.pathname]);

  return (
    <div className="App">
      <Routers />
      <ToastContainer newestOnTop />
    </div>
  );
};

export default App;
